import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import ForMentors from "./pages/ForMentors";
import AboutFounder from "./pages/AboutFounder";
import Learn from "./pages/Learn";
import Admin from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";
import MentorOnboarding from "./pages/MentorOnboarding";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/for-mentors" element={<ForMentors />} />
            <Route path="/mentors-onboarding" element={<MentorOnboarding />} />
            <Route path="/about-founder" element={<AboutFounder />} />
            <Route path="/learn" element={<Learn />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Footer />
          <Toaster position="top-right" />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
